const isUserNotConfirmedError = (error: any): boolean => {
  const code = error.code;
  return code === "UserNotConfirmedException";
};

export default isUserNotConfirmedError;
